import {useEffect} from 'react';

export default function PageTitle(props: { title: string }) {
    useEffect(() => {
        const previous = document.title;
        document.title = props.title;

        return () => {
            document.title = previous;
        };
    }, [props]);

    return null;
}
